import { render, staticRenderFns } from "./UserTicketsToRemove.vue?vue&type=template&id=080e6140"
import script from "./UserTicketsToRemove.vue?vue&type=script&lang=js"
export * from "./UserTicketsToRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports